/**
 * "Modo responsável": adult-only actions (editing, settings, account) are
 * hidden until the caregiver's PIN is entered. It protects against accidental
 * taps by the person communicating; it is not access control (the server
 * still authorises every request by session).
 *
 * Unlocking lasts until "Bloquear"/"Concluir" or `minutes` without activity.
 */
export interface AdultModeState {
  unlockedUntil: number | null;
}

export const LOCKED: AdultModeState = { unlockedUntil: null };

export function isUnlocked(state: AdultModeState, now = Date.now()): boolean {
  return state.unlockedUntil !== null && now < state.unlockedUntil;
}

export function unlock(minutes: number, now = Date.now()): AdultModeState {
  return { unlockedUntil: now + minutes * 60_000 };
}

/** Activity while unlocked pushes the expiry forward; a locked state stays locked. */
export function touch(state: AdultModeState, minutes: number, now = Date.now()): AdultModeState {
  return isUnlocked(state, now) ? unlock(minutes, now) : LOCKED;
}
